//
// Reload Page
//
export const handleReloadPage = {
  type: 'function',
  required: true,
}

export const reloadPage = () => {
  if (!document) {
    return
  }
  document.location.reload()
}

const replaceTokenOnUrlFromCurrentUrl = (context: any, url: string) => {
  const currentUrlParams = new URL(document.location.href).searchParams

  const destination = new URL(url)

  const token = currentUrlParams?.get('_token')
    ? currentUrlParams.get('_token')
    : context.admin_token

  destination.searchParams.set('_token', token)

  return destination.href
}

//
// Navigate to Page
//
export const handleNavigateToPage = {
  type: 'function',
  required: true,
}

export const navigateToPage = (context: any, url: string, newTab: boolean) => {
  if (!document || !context.shop_url) {
    return
  }
  const toUrl = /^(https?:\/\/)/.test(url)
    ? url
    : document.location.origin + '/' + url.replace(/^\//, '')

  const destination = replaceTokenOnUrlFromCurrentUrl(context, toUrl)
  if (!newTab) {
    document.location.href = destination
  } else if (window) {
    window.open(destination, '_blank')?.focus()
  }
}

export const handleNavigateToMboHome = {
  type: 'function',
  required: true,
}

export const navigateToMboHome = (
  context: any,
  params?: Record<string, string>,
  newTab = false,
  target?: string,
) => {
  let url: string | undefined

  if (context.module_catalog_url) {
    url = context.module_catalog_url
  } else if (!document && !window) {
    return
  } else {
    const moduleCatalogMenuEntry =
      // on 8.x.x
      document
        ?.getElementById('subtab-AdminPsMboModuleParent')
        ?.firstElementChild?.getAttribute('href') ||
      // on 1.7.x
      document
        ?.getElementById('subtab-AdminParentModulesCatalog')
        ?.firstElementChild?.getAttribute('href')

    if (moduleCatalogMenuEntry) url = moduleCatalogMenuEntry
  }

  if (url) {
    const urlObject = new URL(url, document.location.origin)

    if (params) {
      Object.entries(params).forEach(([paramsKey, paramsValue]) => {
        urlObject.searchParams.set(paramsKey, paramsValue)
      })
    }

    if (newTab) {
      window.open(urlObject.href, target || '_blank')
    } else {
      window.location.href = urlObject.href
    }
  }
}

export const handleNavigateToMboModuleCatalog = {
  type: 'function',
  required: true,
}

export const navigateToMboModuleCatalog = (
  context: any,
  params?: Record<string, string>,
  scope?: string,
  newTab = false,
) => {
  let url: string | undefined

  if (context.module_catalog_url) {
    url = context.module_catalog_url
  } else if (!document && !window) {
    return
  } else {
    const moduleCatalogMenuEntry =
      // on 8.x.x
      document
        ?.getElementById('subtab-AdminPsMboModuleParent')
        ?.firstElementChild?.getAttribute('href') ||
      // on 1.7.x
      document
        ?.getElementById('subtab-AdminParentModulesCatalog')
        ?.firstElementChild?.getAttribute('href')

    if (moduleCatalogMenuEntry) url = moduleCatalogMenuEntry
  }

  if (url) {
    const urlObject = new URL(url, document.location.origin)

    if (params) {
      Object.entries(params).forEach(([paramsKey, paramsValue]) => {
        urlObject.searchParams.set(paramsKey, paramsValue)
      })
    }

    urlObject.searchParams.set(
      'mbo_cdc_path',
      scope ? `/#/modules/${scope}/` : '/#/modules',
    )

    if (newTab) {
      window.open(urlObject.href, '_blank')
    } else {
      window.location.href = urlObject.href
    }
  }
}

export const handleNavigateToMboThemeCatalog = {
  type: 'function',
  required: true,
}

export const navigateToMboThemeCatalog = (context: any) => {
  if (context.theme_catalog_url) {
    window.location.href = context.theme_catalog_url
    return
  }

  if (!document && !window) {
    return
  }

  const themeCatalogMenuEntry = document
    ?.getElementById('subtab-AdminPsMboTheme')
    ?.firstElementChild?.getAttribute('href')

  if (themeCatalogMenuEntry) window.location.href = themeCatalogMenuEntry
}

export const handleNavigateToMBO = {
  type: 'function',
  required: true,
}

export const navigateToMBO = (context: any, path: string) => {
  if (!document) {
    return
  }

  const mboMenuEntry = document
    ?.getElementById('subtab-AdminPsMboModuleParent')
    ?.firstElementChild?.getAttribute('href')

  const currentUrl = new URL(document.location.href)

  const mboMenuEntryUrlParams = mboMenuEntry
    ? new URL(mboMenuEntry, currentUrl.origin).searchParams
    : null

  const adminPath = currentUrl.pathname
    .split('/')
    .filter((i) => i !== '')
    .slice(0, 2)
    .join('/')
  const destination = new URL([currentUrl.origin, adminPath, path].join('/'))

  const token = mboMenuEntryUrlParams?.get('_token')
    ? mboMenuEntryUrlParams.get('_token')
    : context.admin_token

  destination.searchParams.set('_token', token)

  window.location.href = destination.href
}

//
// Search Params
//
export const useUrlSearchParams = {
  type: 'function',
  required: true,
}

export const urlSearchParams = () => {
  const url = new URL(window.location.toString())

  const getUrlSearchParams = (name: string) => url.searchParams.get(name)
  const setUrlSearchParams = (name: string, value?: string | number) => {
    value = value?.toString().trim()

    if (value === null || value === undefined || value === '') {
      url.searchParams.delete(name)
    } else {
      url.searchParams.set(name, value)
    }

    window.history.replaceState(
      { type: 'mbo_cdc_navigation', href: url.href },
      '',
      url.href,
    )
  }

  return { getUrlSearchParams, setUrlSearchParams }
}

//
// CDC Navigation Params
//
export const handleCdcNavigate = {
  type: 'function',
  required: true,
}

export const cdcNavigate = (cdc_path: string) => {
  const url = new URL(window.location.href)

  url.searchParams.set('mbo_cdc_path', cdc_path)

  window.history.replaceState(
    { type: 'mbo_cdc_navigation', href: url.href },
    '',
    url.href,
  )
}

export const handleNavigateToModuleManagerUpdatesTab = {
  type: 'function',
  required: false,
}

export function navigateToModuleManagerUpdatesTab(context: any) {
  if (!document && !window) {
    return
  }

  if (context.module_manager_updates_tab_url) {
    window.location.href = context.module_manager_updates_tab_url
    return
  }
}
